module.exports = __webpack_public_path__ + "static/media/gallery_17_thumb.eb94dc48.jpg";